import * as z from "zod";

export const autoMergeSpecifiedGroups = {
  name: "autoMergeSpecifiedGroups" as const,
  input: z.object({
    fulfillmentGroupIds: z.array(z.string()),
    waitForCompletion: z.boolean().optional(),
  }),
  output: z.object({ workflowId: z.string().nullable() }),
};
